import { render } from "./StarIcon.vue?vue&type=template&id=0240b612&scoped=true"
const script = {}

import "./StarIcon.vue?vue&type=style&index=0&id=0240b612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0240b612"]])

export default __exports__